import * as React from 'react';
import Container from '@adecco/base-app/src/components/atoms/Container/Container';
import { useAppContext } from '@adecco/base-app/src/utilities/appProvider/appProvider';
import {
  SalaryStyled,
  StyledHeadline,
  SalaryNumbers,
  SalaryRangeNumber,
  SalaryTo,
  SalaryToText,
  Scale,
  ScalePercent,
  StyledParagraph,
} from './Salary.styled';

export interface ISalary {
  title?: string;
  subline?: string;
  salary25?: number;
  salary75?: number;
  description?: string;
}

const Salary: React.FunctionComponent<ISalary> = ({
  title,
  subline,
  salary25,
  salary75,
  description,
}) => {
  const { t } = useAppContext();

  return (
    <Container>
      <SalaryStyled>
        <StyledHeadline skin={2}>{title}</StyledHeadline>
        <StyledHeadline skin={3} subline>
          {subline}
        </StyledHeadline>
        <SalaryNumbers>
          <SalaryRangeNumber>{salary25}€</SalaryRangeNumber>
          <SalaryTo>
            <SalaryToText>{t('general-up-to')}</SalaryToText>
          </SalaryTo>
          <SalaryRangeNumber maxRange>{salary75}€</SalaryRangeNumber>
        </SalaryNumbers>
        <Scale>
          <ScalePercent>25%</ScalePercent>
          <ScalePercent fifty>50%</ScalePercent>
          <ScalePercent>25%</ScalePercent>
        </Scale>
        {description && <StyledParagraph>{description}</StyledParagraph>}
      </SalaryStyled>
    </Container>
  );
};

export default Salary;
